module.exports = __webpack_public_path__ + "static/media/nuCrop validate.87c720c9.JPG";